import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { formatApiError } from "@/lib/api";
import { TagnPayBadge } from "@/components/common";
import { Smartphone } from "lucide-react";

const PRESETS = [
  { email: "vineetnarangofc@gmail.com", pass: "Sugar@Rewards2026", label: "Super Admin (Owner)" },
  { email: "priya.finance@tagnpay.app", pass: "Demo@2026", label: "Finance" },
  { email: "neha.brand@tagnpay.app", pass: "Demo@2026", label: "Brand Manager · TWACHA" },
  { email: "sam.support@tagnpay.app", pass: "Demo@2026", label: "Support (masked)" },
];

export default function Login() {
  const { login } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("vineetnarangofc@gmail.com");
  const [password, setPassword] = useState("Sugar@Rewards2026");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/app/overview");
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || ex.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="hidden lg:flex flex-col justify-between sidebar-dark text-white p-12 relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full tnp-gradient opacity-30 blur-3xl" />
        <div className="relative">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl tnp-gradient flex items-center justify-center font-bold text-xl font-head">S</div>
            <div>
              <div className="font-bold text-lg font-head">SUGAR Cosmetics Group Rewards</div>
              <div className="text-xs text-violet-300 font-semibold tracking-wider">POWERED BY TAGNPAY</div>
            </div>
          </div>
        </div>
        <div className="relative space-y-5">
          <h2 className="text-4xl font-bold leading-tight font-head">Multi-brand loyalty, gamification & payouts in one operations portal.</h2>
          <p className="text-slate-300 text-sm max-w-md">Manage Brownsugar, TWACHA & SOGUUD — QR claims, scheme engine, scratch & spin games, UPI redemptions, and reconciliation. 147 catalog SKUs imported.</p>
          <div className="flex gap-6 pt-4">
            {[["3", "Brands"], ["147", "SKUs"], ["2", "Game formats"]].map(([n, l]) => (
              <div key={l}><div className="text-3xl font-bold font-head">{n}</div><div className="text-xs text-slate-400">{l}</div></div>
            ))}
          </div>
        </div>
        <div className="relative"><TagnPayBadge /></div>
      </div>

      {/* Form */}
      <div className="flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-sm">
          <h1 className="text-2xl font-bold text-slate-900 font-head">Sign in</h1>
          <p className="text-sm text-slate-500 mt-1 mb-6">Operations portal access</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-600">Email</label>
              <input data-testid="admin-login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email"
                className="w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-violet-200" />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-600">Password</label>
              <input data-testid="admin-login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} type="password"
                className="w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-violet-200" />
            </div>
            {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-100 rounded-lg px-3 py-2">{err}</div>}
            <button data-testid="admin-login-submit-button" disabled={loading} type="submit"
              className="w-full tnp-gradient text-white font-semibold py-2.5 rounded-lg hover:opacity-95 transition-opacity disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div className="mt-6">
            <div className="text-xs text-slate-400 mb-2">Quick demo logins</div>
            <div className="grid grid-cols-2 gap-2">
              {PRESETS.map((p) => (
                <button key={p.email} data-testid={`preset-${p.label}`} onClick={() => { setEmail(p.email); setPassword(p.pass); }}
                  className="text-left text-[11px] px-2.5 py-2 rounded-lg border border-slate-200 bg-white hover:border-violet-300 transition-colors">
                  <div className="font-semibold text-slate-700">{p.label}</div>
                  <div className="text-slate-400 truncate">{p.email}</div>
                </button>
              ))}
            </div>
          </div>
          <button onClick={() => nav("/simulator")} className="mt-5 w-full flex items-center justify-center gap-2 text-sm text-violet-700 font-semibold py-2 rounded-lg border border-violet-100 bg-violet-50 hover:bg-violet-100 transition-colors">
            <Smartphone size={15} /> Open Consumer Simulator
          </button>
          <div className="mt-6 text-center"><TagnPayBadge /></div>
        </div>
      </div>
    </div>
  );
}
